module.exports = __webpack_public_path__ + "img/jdoodle.113077a7.png";